<template>
  <div>
    <Head v-if="BeforeEventData" />

    <div class="breadcrumb_box" aria-label="breadcrumb">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">首頁</router-link></li>
        <li class="breadcrumb-item" v-if="BeforeEventData.Event">{{ BeforeEventData.Project.Name }}</li>
        <li class="breadcrumb-item active" aria-current="page">報名資料</li>
      </ol>
    </div>
    <div class="wrapper member_information factory" v-if="BeforeEventData.BeforeInfo">
      <section class="main">
        <div class="container">
          <div class="step_box">
            <div class="step">報名資料</div>
          </div>
          <h1>
            {{ BeforeEventData.Project.Name }}
            <div class="btn_home">
              <router-link to="/" tag="button">返回首頁</router-link>
            </div>
          </h1>
          <div id="stet_1" class="box show">
            <!-- 20250303 新增 三張圖片 ↓ -->
            <div class="banner_box"
              v-if="BeforeEventData.Project.BeforeImage || BeforeEventData.Project.BeforeImage2 || BeforeEventData.Project.BeforeImage3">
              <button type="button" class="img_box" v-if="BeforeEventData.Project.BeforeImage"
                @click="openModal(BeforeEventData.SiteUrl + BeforeEventData.Project.BeforeImage)">
                <img :src="BeforeEventData.SiteUrl + BeforeEventData.Project.BeforeImage" alt="">
              </button>
              <button type="button" class="img_box" v-if="BeforeEventData.Project.BeforeImage2"
                @click="openModal(BeforeEventData.SiteUrl + BeforeEventData.Project.BeforeImage2)">
                <img :src="BeforeEventData.SiteUrl + BeforeEventData.Project.BeforeImage2" alt="">
              </button>
              <button type="button" class="img_box" v-if="BeforeEventData.Project.BeforeImage3"
                @click="openModal(BeforeEventData.SiteUrl + BeforeEventData.Project.BeforeImage3)">
                <img :src="BeforeEventData.SiteUrl + BeforeEventData.Project.BeforeImage3" alt="">
              </button>
            </div>
            <div class="form-group">
              <label for=""><span>[必填]</span>餐飲品牌名稱/店名</label>
              <input type="text" class="form-control" v-model="BeforeEventData.BeforeInfo.BrandName" data-required="1"
                data-required-msg="請填寫餐飲品牌名稱/店名" aria-describedby="" placeholder="請填寫餐飲品牌名稱/店名">
            </div>
            <div class="form-group">
              <label for=""><span>[必填]</span>業者代表姓名</label>
              <input type="text" class="form-control" v-model="BeforeEventData.BeforeInfo.RepresentativeName"
                data-required="1" data-required-msg="請填寫業者代表姓名" aria-describedby="" placeholder="請填寫業者代表姓名">
            </div>
            <div class="form-group">
              <label for=""><span>[必填]</span>職稱</label>
              <input type="text" class="form-control" v-model="BeforeEventData.BeforeInfo.Title" data-required="1"
                data-required-msg="請填寫職稱" aria-describedby="" placeholder="請填寫職稱">
            </div>
            <div class="form-group">
              <label for=""><span>[必填]</span>聯絡手機</label>
              <input type="text" class="form-control" v-model="BeforeEventData.BeforeInfo.Mobile" data-required="1"
                data-required-msg="請填寫聯絡手機" aria-describedby="" placeholder="請填寫聯絡手機">
            </div>
            <div class="form-group">
              <label for=""><span>[必填]</span>電子信箱</label>
              <!-- <input type="email" class="form-control" v-model="BeforeEventData.BeforeInfo.Email" data-required="1"
                data-required-msg="請填寫電子信箱" aria-describedby="" placeholder="請填寫電子信箱"> -->
              <input type="text" class="form-control" v-model="BeforeEventData.BeforeInfo.Email" data-required="1"
                data-required-msg="請填寫電子信箱" aria-describedby="" placeholder="請填寫電子信箱">
            </div>
            <div class="form-group">
              <label for=""><span>[必填]</span>公司電話</label>
              <input type="text" class="form-control" v-model="BeforeEventData.BeforeInfo.CompanyPhone"
                data-required="1" data-required-msg="請填寫公司電話" aria-describedby="" placeholder="請填寫公司電話">
            </div>
            <div class="form-group">
              <label for=""><span>[必填]</span>公司地址</label>
              <input type="text" class="form-control" v-model="BeforeEventData.BeforeInfo.CompanyAddress"
                data-required="1" data-required-msg="請填寫公司地址" aria-describedby="" placeholder="請填寫公司地址">
            </div>
            <div class="form-group">
              <label for=""><span>[必填]</span>官網</label>
              <input type="text" class="form-control" v-model="BeforeEventData.BeforeInfo.Website" data-required="1"
                data-required-msg="請填寫官網" aria-describedby="" placeholder="請填寫官網">
            </div>
            <div class="form-group">
              <label for=""><span>[必填]</span>業者代表性別</label>
              <div class="check_group radio">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="RepresentativeGender" id="RepresentativeGender1"
                    v-bind:value="1" v-model="BeforeEventData.BeforeInfo.RepresentativeGender">
                  <label class="form-check-label" for="RepresentativeGender1">
                    男
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="RepresentativeGender" id="RepresentativeGender2"
                    v-bind:value="2" v-model="BeforeEventData.BeforeInfo.RepresentativeGender">
                  <label class="form-check-label" for="RepresentativeGender2">
                    女
                  </label>
                </div>
              </div>
            </div>
            <hr />
            <div class="form-group full certificate">
              <label for=""><span>[必填]</span>參加場次</label>
              <div class="check_group">
                <div class="form-check" v-for="(Session, index) in BeforeEventData.Sessions" :key="index">
                  <input type="checkbox" class="form-check-input" :value="Session.value" :id="'Sessions_' + index"
                    v-model="Sessions">
                  <label class="form-check-label" :for="'Sessions_' + index">{{ Session.text }}</label>
                </div>
              </div>
            </div>
            <hr />
            <div class="form-group full certificate">
              <label for=""><span>[必填]</span>對於「推動餐飲服務業優質成長暨國際推廣計畫」中的哪一項有興趣？</label>
              <div class="check_group">
                <div class="form-check" v-for="BeforeType in BeforeEventData.BeforeTypes" :key="BeforeType.BTId">
                  <input type="checkbox" class="form-check-input" :value="BeforeType.BTId"
                    :id="'InterestedInGrowthPlan_' + BeforeType.BTId" v-model="InterestedInGrowthPlan">
                  <label class="form-check-label" :for="'InterestedInGrowthPlan_' + BeforeType.BTId">{{ BeforeType.Name
                  }}</label>
                </div>
              </div>
            </div>
            <hr />
            <div class="form-group full certificate">
              <label for=""><span>[必填]</span>國際商談會 商洽國家意願調查</label>
              <div class="check_group">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="InterestMatchmakingUSA"
                    v-model="BeforeEventData.BeforeInfo.InterestMatchmakingUSA">
                  <label class="form-check-label" for="InterestMatchmakingUSA">美國</label>
                </div>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="InterestMatchmakingUK"
                    v-model="BeforeEventData.BeforeInfo.InterestMatchmakingUK">
                  <label class="form-check-label" for="InterestMatchmakingUK">英國</label>
                </div>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="InterestMatchmakingPH"
                    v-model="BeforeEventData.BeforeInfo.InterestMatchmakingPH">
                  <label class="form-check-label" for="InterestMatchmakingPH">菲律賓</label>
                </div>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="InterestMatchmakingJP"
                    v-model="BeforeEventData.BeforeInfo.InterestMatchmakingJP">
                  <label class="form-check-label" for="InterestMatchmakingJP">日本</label>
                </div>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="InterestMatchmakingKR"
                    v-model="BeforeEventData.BeforeInfo.InterestMatchmakingKR">
                  <label class="form-check-label" for="InterestMatchmakingKR">韓國</label>
                </div>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="InterestMatchmakingMY"
                    v-model="BeforeEventData.BeforeInfo.InterestMatchmakingMY">
                  <label class="form-check-label" for="InterestMatchmakingMY">馬來西亞</label>
                </div>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="InterestMatchmakingSG"
                    v-model="BeforeEventData.BeforeInfo.InterestMatchmakingSG">
                  <label class="form-check-label" for="InterestMatchmakingSG">新加坡</label>
                </div>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="InterestMatchmakingHK"
                    v-model="BeforeEventData.BeforeInfo.InterestMatchmakingHK">
                  <label class="form-check-label" for="InterestMatchmakingHK">香港</label>
                </div>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="InterestMatchmakingOther"
                    v-model="BeforeEventData.BeforeInfo.InterestMatchmakingOther">
                  <label class="form-check-label" for="InterestMatchmakingOther">其他</label>
                  <input type="text" class="form-control" v-if="BeforeEventData.BeforeInfo.InterestMatchmakingOther"
                    v-model="BeforeEventData.BeforeInfo.InterestMatchmakingOtherContent"
                    :data-required="BeforeEventData.BeforeInfo.InterestMatchmakingOther ? '1' : '0'"
                    data-required-msg="請填寫國家名稱" aria-describedby="" placeholder="請填寫國家名稱">
                </div>
              </div>
            </div>
            <div class="form-group full pass">
              <label for="">國際商談會 商洽資訊調查(否則免填)</label>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="HasExportableProducts"
                  v-model="BeforeEventData.BeforeInfo.HasExportableProducts">
                <label class="form-check-label" for="HasExportableProducts">是否已有可外銷的產品(已有品質認證或國際標準符合)</label>
                <input type="text" class="form-control" v-if="BeforeEventData.BeforeInfo.HasExportableProducts"
                  v-model="BeforeEventData.BeforeInfo.HasExportableProductsContent"
                  :data-required="BeforeEventData.BeforeInfo.HasExportableProducts ? '1' : '0'"
                  data-required-msg="請填寫說明" aria-describedby="" placeholder="請填寫說明">
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="HasTradePartners"
                  v-model="BeforeEventData.BeforeInfo.HasTradePartners">
                <label class="form-check-label" for="HasTradePartners">是否已有合作的通路商/貿易商/經銷代理商</label>
                <input type="text" class="form-control" v-if="BeforeEventData.BeforeInfo.HasTradePartners"
                  v-model="BeforeEventData.BeforeInfo.HasTradePartnersContent"
                  :data-required="BeforeEventData.BeforeInfo.HasTradePartners ? '1' : '0'" data-required-msg="請填寫說明"
                  aria-describedby="" placeholder="請填寫說明">
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="HasExportMarkets"
                  v-model="BeforeEventData.BeforeInfo.HasExportMarkets">
                <label class="form-check-label" for="HasExportMarkets">是否已有主要出口市場和目標市場?</label>
                <input type="text" class="form-control" v-if="BeforeEventData.BeforeInfo.HasExportMarkets"
                  v-model="BeforeEventData.BeforeInfo.HasExportMarketsContent"
                  :data-required="BeforeEventData.BeforeInfo.HasExportMarkets ? '1' : '0'" data-required-msg="請填寫說明"
                  aria-describedby="" placeholder="請填寫說明">
              </div>
            </div>
            <hr />
            <div class="form-group full">
              <label for="">其他政府相關輔導資訊諮詢</label>
              <textarea rows="5" v-model="BeforeEventData.BeforeInfo.GovSupportInquiry" aria-describedby=""
                data-required="0" data-required-msg="請填寫其他政府相關輔導資訊諮詢" placeholder="請填寫其他政府相關輔導資訊諮詢"></textarea>
            </div>
            <hr />
            <div class="form-group full certificate">
              <label
                for=""><span>[必填]</span>本問卷依據個資法蒐集、處理及利用您的個人資料包含識別個人姓名、行動電話、電子郵件地址等。上述個人資料之蒐集、處理及利用，將僅限本問卷業務需要使用，並遵守個資法之規定妥善</label>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="PersonalDataConsent"
                  v-model="BeforeEventData.BeforeInfo.PersonalDataConsent" required>
                <label class="form-check-label"
                  for="PersonalDataConsent">本人經主辦單位告知《個人資料保護法》相關事項，本人已清楚瞭解本問卷蒐集、處理或利用本人個人資料之應告知事項。</label>
              </div>
            </div>
            <div class="btn_box">
              <button @click="save()">{{ BeforeEventData.BeforeInfo.BIId == -1 ? '送　　出' : '更　　新' }}</button>
            </div>
          </div>
        </div>
      </section>
    </div><!-- wrapper -->

    <!-- 20250303 新增 彈跳視窗 -->
    <div class="modal fade" id="imgModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <div class="img_box" data-dismiss="modal">
              <img src="" alt="">
              <!-- 20250303 vue裡面 img要修改 -->
              <img :src="modalImageSrc" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);


import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "BeforeEvent",
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      BeforeEventData: {},
      InterestedInGrowthPlan: [],
      Sessions: [],
      modalImageSrc: "",
    };
  },
  beforeCreate: function () {
    if (!$cookies.isKey("is_login_token")) {
      Swal.fire({
        title: "請先登入帳號",
        icon: "info",
        allowOutsideClick: false,
        heightAuto: false,
        willClose: () => {
          this.$router.push({
            name: "LoginForUser",
          });
        },
      });
      return;
    }
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/BeforeInfo",
        {
          params: { token: $cookies.get("is_login_token") },
        }
      )
      .then((response) => {
        this.BeforeEventData = response.data;
        if (this.BeforeEventData.BeforeInfo && this.BeforeEventData.Project) {
          this.BeforeEventData.BeforeInfo.PId = this.BeforeEventData.Project.PId;
        }
        this.InterestedInGrowthPlan = $.parseJSON(this.BeforeEventData.BeforeInfo.InterestedInGrowthPlan);
        this.Sessions = $.parseJSON(this.BeforeEventData.BeforeInfo.Sessions);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
  },
  updated: function () {
  },
  methods: {
    save() {
      Swal.fire({
        title: "請稍候...",
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      var hasError = false;
      let that = this;
      $("#stet_1").find("[data-required='1']").each(function () {
        var input = $(this);
        if (!input.val() || input.val() == '-1') {
          Swal.fire({
            title: "錯誤",
            text: input.data("required-msg"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定",
            heightAuto: false,
          });
          hasError = true;
          return false;
        } else if (input.attr("type") == "email" &&
          !Validate.reg_email(input.val())) {
          Swal.fire({
            title: "錯誤",
            text: "Email格式錯誤",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定",
            heightAuto: false,
          });
          hasError = true;
          return false;
        } else if (input.attr("type") == "number" &&
          input.val() < 0) {
          Swal.fire({
            title: "錯誤",
            text: "數字不可小於0",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定",
            heightAuto: false,
          });
          hasError = true;
          return false;
        }
      });
      if (that.BeforeEventData.BeforeInfo.Mobile != '' &&
        !Validate.reg_number(that.BeforeEventData.BeforeInfo.Mobile)) {
        that.Step = 1;
        Swal.fire({
          heightAuto: false,
          title: "錯誤",
          text: "電話號碼格式錯誤",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
        });
        return;
      }
      if (that.BeforeEventData.BeforeInfo.CompanyPhone != '' &&
        !Validate.reg_number(that.BeforeEventData.BeforeInfo.CompanyPhone)) {
        that.Step = 1;
        Swal.fire({
          heightAuto: false,
          title: "錯誤",
          text: "電話號碼格式錯誤",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
        });
        return;
      }
      if (that.Sessions.length == 0) {
        Swal.fire({
          heightAuto: false,
          title: "錯誤",
          text: "請至少勾選一個「參加場次」項目",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
        });
        return;
      }
      if (that.InterestedInGrowthPlan.length == 0) {
        Swal.fire({
          heightAuto: false,
          title: "錯誤",
          text: "請至少勾選一項有興趣的「推動餐飲服務業優質成長暨國際推廣計畫」項目",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
        });
        return;
      }
      if (!that.BeforeEventData.BeforeInfo.InterestMatchmakingUSA &&
        !that.BeforeEventData.BeforeInfo.InterestMatchmakingUK &&
        !that.BeforeEventData.BeforeInfo.InterestMatchmakingPH &&
        !that.BeforeEventData.BeforeInfo.InterestMatchmakingJP &&
        !that.BeforeEventData.BeforeInfo.InterestMatchmakingKR &&
        !that.BeforeEventData.BeforeInfo.InterestMatchmakingOther
      ) {
        Swal.fire({
          heightAuto: false,
          title: "錯誤",
          text: "請至少勾選一個意願商洽國家",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
        });
        return;
      }
      if (!that.BeforeEventData.BeforeInfo.PersonalDataConsent) {
        Swal.fire({
          heightAuto: false,
          title: "錯誤",
          text: "請確認您已清楚瞭解本問卷蒐集、處理或利用本人個人資料之應告知事項並勾選該項目",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
        });
        return;
      }
      if (hasError) {
        return;
      }
      that.BeforeEventData.BeforeInfo.InterestedInGrowthPlan = JSON.stringify(that.InterestedInGrowthPlan);
      that.BeforeEventData.BeforeInfo.Sessions = JSON.stringify(that.Sessions);
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/BeforeInfo",
        type: "post",
        data: {
          BeforeInfoJson: JSON.stringify(that.BeforeEventData.BeforeInfo),
          token: $cookies.get("is_login_token")
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.ok) {
            Swal.fire({
              title: "報名成功",
              //text: "即將重整頁面",
              icon: "success",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
              //timer: 1500,
              willClose: () => {
                location.reload();
              },
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        }
      });
    },
    convertDatetimeString(time, format) {
      var date = new Date(
        time.replace(
          /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
          "$4:$5:$6 $2/$3/$1"
        )
      );
      return moment(date).format(format);
    },
    openModal(imageSrc) {
      this.modalImageSrc = imageSrc;  // 設定要顯示的圖片
      $('#imgModal').modal('show');
    },
    closeModal() {
      $('#imgModal').modal('hide');
    }
  },
};
</script>
